module.exports = __webpack_public_path__ + "img/1.c9e31214.png";